export default "__VITE_ASSET__Xanu9Ubk__"